<template>
  <div class="bg-light-page d-flex flex-column justify-content-between" style="max-height: 78vh;" v-if="data.room_rate">
    
    <div class="p-4" style="overflow-y: auto;">
      <!-- GENERAL INFORMATION -->
      <div class="mb-4 d-flex align-items-center">
        <div class="flex-shrink-0 light-box-shadow rounded-3 border-form mr-3" style="height: 86px; width: 80px;">
          <img :src="roomImage" class="img-fit rounded-3 cursor-pointer" >
        </div>
        <div>
          <p class="body-1-4 mb-0">{{data.room_rate.name}}</p>
          <div class="d-flex align-items-center">
            <span class="body-2 mb-0" style="width: 36px;">Qty</span>  
            <span class="body-2-4 mb-0">: {{data.qty}} {{$t('hotel.unit-type.'+data.room_rate.room_type.type+'.unit')}}</span>  
          </div>
          <div class="d-flex mb-1 align-items-center">
            <span class="body-2 mb-0" style="width: 36px;">Date</span>  
            <span class="body-2-4 mb-0">: {{ $formatDateRange(getBeFilter.date.check_in,getBeFilter.date.check_out) }}</span>  
          </div>
          <p class="mb-0 font-lato ls-0-25 text-14 text-green cursor-pointer underline" @click="openDetail">See room detail</p>
        </div>
      </div>

      <!-- PAX -->
      <div class="w-100 box-shadow-main rounded-6 border-form mb-4 bg-white" v-for="(guest,index) in pax">
        <div v-if="pax.length > 1" class="p-3 border-b-form bg-green-alpha">
          <p class="mb-0 body-1-4 text-dark">Room {{index+1}}</p>
        </div>
        <div class="px-3">
          <div 
            :id="`room-${typeIndex}`"
            v-for="(type,typeIndex) in paxType" 
            class="w-100 py-3" 
            :class="{'border-b-form': typeIndex + 1 < paxType.length}">
            <div class="d-flex align-items-center justify-content-between">
              <div class="pr-3">
                <div>
                  <p class="mb-0 body-2-4">{{ type.title }}</p>
                  <p class="mb-0 body-2-2-1">{{ type.subtitle }}</p>
                </div>
              </div>
              <div class="flex-shrink-0">
                <div class="d-flex align-items-center justify-content-between">
                  <img 
                    v-if="guest[type.id] <= type.minimum" 
                    src="../../../assets/img/icon/decrement.png"
                    class="cursor-disable bg-light border rounded-100 p-2" width="30">
                  <img 
                    v-else 
                    src="../../../assets/img/icon/minus-black.png"
                    class="cursor-pointer border-form rounded-100 p-2" width="30"
                    @click="toggleCounter(index,'min', type.id, type.minimum)">
  
                  <p class="mb-0 font-lato text-16 text-center" style="width: 42px;">{{guest[type.id]}}</p>
                  <img 
                    src="../../../assets/img/icon/plus-black.png"
                    class="cursor-pointer border-form rounded-100 p-2" width="30"
                    @click="toggleCounter(index,'plus', type.id)">
                </div>
              </div>
            </div>  
            
            <div 
              v-if="
                showChildAgeForm 
                && (type.id === 'child' || type.id === 'infant') 
                && $isNotEmptyV3(age[type.id][index])" 
              class="w-100 mt-2">
              <div 
                v-for="(guestAge, guestAgeIndex) in age[type.id][index]" 
                class="d-flex align-items-center justify-content-between w-100 mb-2 rounded-6 p-2 bg-white"
                :class="$v.age[type.id].$each[index].$each[guestAgeIndex].$error ? 'border-danger' : 'border-form'">
                <p class="mb-0 body-3-1 flex-shrink-0">
                  {{ `#${guestAgeIndex+1} ${$capitalize(type.id)}'s age` }}
                  <span class="text-danger" v-if="isChildAgeRequired">*</span> :
                </p>
                <CustomDropdown 
                  v-model="guestAge.show" 
                  :key="`${type.id}-${index}-${guestAgeIndex}`" 
                  :min-width="130" 
                  align="right">
                  <template #trigger>
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="mb-0 body-3-1 flex-shrink-0" :class="$v.age[type.id].$each[index].$each[guestAgeIndex].$error ? 'text-danger' : 'text-dark'">
                        {{ 
                          guestAge.age !== "" 
                          ? `${guestAge.age == 0 ? '<1' : guestAge.age} ${$pluralWord(guestAge.age, 'year')} old` 
                          : `Please select ${type.id}'s age` 
                        }}
                      </p>
                      <div class="lh-0 ml-2">
                        <svg class="delay" :class="{'transform-180' : guestAge.show}" height='6' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path d='M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z' :fill="$v.age[type.id].$each[index].$each[guestAgeIndex].$error ? '#dc3545' : '#777'"/>
                        </svg>
                      </div>
                    </div>
                  </template>
                  <template #content>
                    <div class="w-100" style="height: 200px;overflow-y: scroll;">
                      <span 
                        v-for="age in ageOptions[type.id]" 
                        @click="selectChildAge(type.id, index,guestAgeIndex,age)"
                        class="d-block w-100 cursor-pointer item-hover p-2 border-b-form body-3-1">
                          {{ `${age == 0 ? '<1' : age} ${$pluralWord(age, 'year')} old` }}
                      </span>
                    </div>
                  </template>
                </CustomDropdown>
              </div>
            </div>

            <p class="mb-0 body-3-3-1" v-if="extra_guest[index][type.id] > 0"><i>{{ printExtraGuest(extra_guest[index][type.id], type.id) }}</i></p>

          </div>
        </div>
      </div>
  
      <!-- PRICE -->
      <div class="w-100 box-shadow-main rounded-6 border-form mb-4 bg-white">
        <div class="p-3 mb-3 border-b-form bg-green-alpha">
          <p class="mb-0 body-1-4 text-dark">Price Detail</p>
        </div>
        <div class="px-3">
          <div class="d-flex align-items-center justify-content-between mb-2-5">
            <p class="mb-0 body-2-1">{{total_guest_included}}x {{$t('hotel.rate-breakdown.guest-included')}}</p>
            <p class="mb-0 font-lato text-14">{{$formatCurrency(total_price.included)}}</p>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-2-5" v-if="total_price.discount < 0">
            <p class="mb-0 body-2-1">Discount</p>
            <p class="mb-0 font-lato text-14">{{$formatCurrency(total_price.discount)}}</p>
          </div>
          <div v-for="extra in extraPriceList" class="d-flex align-items-center justify-content-between mb-2-5">
            <p class="mb-0 body-2-1">{{ extra.label }}</p>
            <p class="mb-0 font-lato text-14">{{$formatCurrency(extra.price)}}</p>
          </div>
          <div class="d-flex align-items-center justify-content-between mb-2-5 border-t-form-2-dashed pt-2-5">
            <p class="mb-0 body-1-4">Total</p>
            <p class="mb-0 font-lato text-16">{{$formatCurrency(total_price.total)}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- BUTTON -->
    <div class="w-100 bg-white px-4 py-3 border-t-form">
      <state-button block variant="primary" size="lg" :click="submitPax">Save Changes</state-button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters,mapMutations } from 'vuex';
  import CustomDropdown from '../../general/CustomDropdown.vue';
  import { validationMixin } from "vuelidate";
  const { required } = require("vuelidate/lib/validators");

  export default {
    components:{
      CustomDropdown
    },
    props: {
      data:{
        type: Object,
        default: () => {}
      },
      validateChildAge:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        pax: [],
        age:{
          child: [],
          infant: []
        }
      }
    },
    mixins: [validationMixin],
    validations: {
      age:{
        child: {
          $each: {
            $each: {
              age: { required }
            }
          }
        },
        infant: {
          $each: {
            $each: {
              age: { required }
            }
          }
        },
      }
    },
    computed:{
      ...mapGetters(['getBeFilter','getMerchant']),
      roomImage(){
        if(this.$isEmpty(this.data)) return null
        const { image } = this.data.room_rate.room_type
        return this.$isEmpty(image) ? this.getMerchant.image_url : image[0].image_url
      },
      total_night(){
        let different = moment(this.getBeFilter.date.check_out).diff(this.getBeFilter.date.check_in, 'd')
        return different
      },
      paxType(){
        let fullPax = [{ id: 'adult', minimum: 1, title: this.$t('hotel.adults.adults'), subtitle: this.getMerchant.adult_description }];
        if(this.getMerchant.search_room_is_show_filter_pax_child){
          fullPax.push({ id: 'child', minimum: 0, title: this.$t('hotel.children.children'), subtitle: this.getMerchant.children_description })
        }
        if(this.getMerchant.search_room_is_show_filter_pax_infant){
          fullPax.push({ id: 'infant', minimum: 0, title: this.$t('hotel.infants.infants'), subtitle: this.getMerchant.infant_description })
        }
        
        return fullPax
      },
      max_guest(){
        let mg_rate = this.data.room_rate.rate.max_guests
        let mg_room_type = this.data.room_rate.room_type.max_guests
        return mg_rate == null ? mg_room_type : mg_rate
      },
      maxGuest() {
        const { rate, room_type } = this.data.room_rate;
        const maxGuestSource = rate.max_guests ? rate : room_type;

        return {
          use_max_guest_by_pax: maxGuestSource.use_max_guest_by_pax || false,
          max_guests: maxGuestSource.max_guests || null,
          max_guest_adult: maxGuestSource.max_guest_adult || 0,
          max_guest_children: maxGuestSource.max_guest_children || 0,
          max_guest_infant: maxGuestSource.max_guest_infant || 0,
        };
      },
      guest_included(){
        return this.data.room_rate.rate.guest_included
      },
      total_guest_included(){
        let total_guest = this.pax.reduce((acc,crt)=>{
          let total = crt.adult+crt.child+crt.infant
          return acc+total
        },0)

        let total_guest_included = this.guest_included*this.data.qty 
        
        return total_guest > total_guest_included ? total_guest_included : total_guest
      },
      extra_guest(){
        let extra = []

        this.pax.forEach((item,index)=>{
          let data = { adult: 0, child: 0, infant: 0 }
          const { use_max_guest_by_pax, max_guests, max_guest_adult, max_guest_children, max_guest_infant } = this.maxGuest;
          let totalGuest = Object.values(item).reduce((sum, value) => sum + value, 0);
          if(totalGuest > this.guest_included){
            if(use_max_guest_by_pax){
              const GUEST_TYPE = ['infant','child', 'adult'];
              const maxGuestType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant }
              
              let remainingGuest = totalGuest - this.guest_included;
              for (const type of GUEST_TYPE){
                if(remainingGuest > 0 && item[type] > 0){
                  const extraFinal = Math.min(remainingGuest, maxGuestType[type]);
                  data[type] = extraFinal;
                  remainingGuest -= extraFinal;
                }
              }
              
            }else{
              if(item.adult >= this.guest_included){
                data = {
                  adult: item.adult-this.guest_included,
                  child: item.child,
                  infant: item.infant
                }
              }else{
                let remaining_total_included = {
                  child: this.guest_included - item.adult,
                  infant: this.guest_included - item.adult - item.child
                }
                if(item.child >= remaining_total_included.child){
                  data.child = item.child - remaining_total_included.child
                  data.infant = item.infant
                }else{
                  if(item.infant >= remaining_total_included.infant){
                    data.infant = item.infant - remaining_total_included.infant
                  }
                }
              }
            }
          }
          extra.push(data)
        })

        return extra
      },
      extra_guest_total(){
        let data = {
          adult: 0,
          child: 0,
          infant: 0
        }
        this.extra_guest.forEach(item=>{
          data.adult += item.adult
          data.child += item.child
          data.infant += item.infant
        })
        return data
      },
      total_price(){
        const GUEST_LIST = ['adult', 'child', 'infant'];

        let data = {
          included: 0,
          discount: 0,
          extra:{ adult: 0, child: 0, infant: 0 },
          total: 0
        }
        
        const calculateExtraGuest = (type, index, currentValue, extraPerDate) => {
          const isExtraGuestExist = this.extra_guest[index][type] > 0;
          return isExtraGuestExist ? (extraPerDate[type].amount * this.extra_guest[index][type]) : currentValue;
        }
        
        this.pax.forEach((item_pax,pax_index)=>{
          const guestInclued = Object.values(item_pax).reduce((sum, val) => sum + val, 0);
          
          this.data.room_rate.dates.forEach(item=>{
            const { price, promotion } = this.$calculatePriceByPax(guestInclued, item, this.data.room_rate.rate.guest_included) 
            
            data.included += price
            data.discount += promotion

            GUEST_LIST.forEach(guest => {
              data.extra[guest] = calculateExtraGuest(guest, pax_index, data.extra[guest], item.extra_guest);
            })
          })
        })
        
        data.total = data.included+data.discount+data.extra.adult+data.extra.child+data.extra.infant

        return data
      },
      showChildAgeForm(){
        return this.getMerchant.booking_engine_child_age !== "HIDE"
      },
      isChildAgeRequired(){
        return this.getMerchant.booking_engine_child_age === "REQUIRED"
      },
      ageOptions(){
        let child = [];
        let infant = [];
        const { 
          children_age_start: childStart = 0,
          children_age_end: childEnd = 0,
          infant_age_start: infantStart = 0,
          infant_age_end: infantEnd = 0,
        } = this.getMerchant;

        for (let i = childStart; i <= childEnd; i++) child.push(i);
        for (let i = infantStart; i <= infantEnd; i++) infant.push(i);

        return { child, infant }; 
      },
      extraPriceList(){
        let priceList = [];

        for(const key in this.extra_guest_total){
          const value = this.extra_guest_total[key]
          if(this.$isNotEmptyV3(value)){
            priceList.push({
              price: this.total_price.extra[key],
              label: `${value}x ${this.$t('hotel.rate-breakdown.extra-' + key + 's')}` 
            })
          }
        }

        return priceList;
      }
    },
    mounted(){
      this.setupData()
    },
    methods:{
      ...mapMutations(['BeManipulateRoomRateGuest']),
      close(){
        this.$emit('close')
      },
      openDetail(){
        this.$emit('close')
        this.$emit('openDetail',this.data)
      },
      assignChildAge(type, savedData, qty){
        if(this.$isNotEmptyV2(savedData)){
          const agePerRoom = savedData.map(age => ({ age, show: false }))
          this.age[type].push(agePerRoom)
        }else{
          let agePerRoom = []
          if(this.$isNotEmptyV3(qty)){
            for (let i = 0; i < qty; i++) agePerRoom.push({ age: "", show: false });
          }
          this.age[type].push(agePerRoom)
        }
      },
      setupData(){
        const { guestIndex = null } = this.data;
        const guestList = this.$isEmpty(guestIndex) ? this.data.guest : [this.data.guest[guestIndex]] 
        
        guestList.forEach((item,index)=>{
          let cloned_data = this.$deepCopy(item)
          let adjust_pax = Object.entries(cloned_data.included).reduce((acc, [key, value]) =>({ ...acc, [key]: (acc[key] || 0) + value }), { ...cloned_data.extra });
          this.pax.push(adjust_pax)      
          const GUEST_NEED_AGE = ['child', 'infant'];
          if(this.showChildAgeForm){
            GUEST_NEED_AGE.forEach(gst => {
              const isSavedAgeExist = this.$isNotEmptyV2(item.age) && this.$isNotEmptyV2(item.age[gst])
              const savedDataAge = isSavedAgeExist ? item.age[gst] : null;
              this.assignChildAge(gst, savedDataAge, adjust_pax[gst])
            })
            
            const isLast = this.$isEmpty(guestIndex) ? index + 1 === this.data.guest.length : true
            if(isLast && this.validateChildAge){
              setTimeout(() => {
                this.valdiateChildAge()
              }, 300);
            }
          }
        })
      },
      toggleCounter(index,type,field, minimum = 0){
        const isDecrementHitMinimum = type == 'min' && this.pax[index][field] <= minimum
        if(isDecrementHitMinimum) return;
        
        const {
          use_max_guest_by_pax,
          max_guests,
          max_guest_adult,
          max_guest_children,
          max_guest_infant,
        } = this.maxGuest;

        const totalGuest = Object.values(this.pax[index]).reduce((sum, value) => sum + value, 0)
        const maxGuestType = { adult: max_guest_adult, child: max_guest_children, infant: max_guest_infant}

        const canChangeUpTotal = totalGuest < max_guests
        const canChangeUpSpecific = this.pax[index][field] < maxGuestType[field] && canChangeUpTotal
        const canChangeUp = use_max_guest_by_pax ? canChangeUpSpecific : canChangeUpTotal;
        
        if(type == 'min' || (type == 'plus' && canChangeUp)){
          const currentPax = this.pax[index][field];
          this.pax[index][field] = type == 'min' ? currentPax-1 : currentPax+1;
          
          const isChildOrInfant = field === 'child' || field === 'infant';
          if(this.showChildAgeForm && isChildOrInfant){
            if(type === 'plus') {
              this.age[field][index].push({
                age: "",
                show: false
              });
            } else {
              this.age[field][index].pop();
            }
          }
        }else{
          console.log("Anda sudah mencapai limit")
        }
      },
      printExtraGuest(num,type){
        let base = 'counted as extra guest'
        let plural = num > 1 ? 'are' : 'is'
        let text = `${num} ${this.$pluralWord(num,type)} ${plural} ${base}${num>1?'s':''}`
        return text
      },
      selectChildAge(field, parentIndex, childIndex, value){
        this.$set(this.age[field][parentIndex], childIndex, {show: false, age: value})
      },
      valdiateChildAge(){
        this.$v.$touch();
        if(this.$v.$invalid){
          let indexNotValid = Object.values(this.$v.age.child.$each.$iter).findIndex(parent => parent.$error)
          if(indexNotValid === -1){
            indexNotValid = Object.values(this.$v.age.infant.$each.$iter).findIndex(parent => parent.$error)
          }
          
          this.$smoothScroll(`room-${indexNotValid}`)
          return false;
        }
        return true
      },
      async submitPax(){
        if(this.isChildAgeRequired){
          const childAgeValidation = this.valdiateChildAge();
          if(!childAgeValidation) return Promise.resolve();
        }
        setTimeout(()=>{
          const { guestIndex = null } = this.data;
          
          let params = { 
            id: this.data.room_rate.id, 
            guest: {
              included: this.$deepCopy(this.pax),
              extra: this.extra_guest,
            } 
          }
          if(this.$isNotEmptyV2(guestIndex)) params.guest_index = guestIndex;
          
          if(this.showChildAgeForm) params.guest_age = {
            child: this.age.child.map(group => group.map(guest => guest.age)), 
            infant: this.age.infant.map(group => group.map(guest => guest.age)), 
          }
          
          this.pax.forEach((item,index)=>{
            params.guest.included[index].adult -= this.extra_guest[index].adult
            params.guest.included[index].child -= this.extra_guest[index].child
            params.guest.included[index].infant -= this.extra_guest[index].infant
          })
          this.BeManipulateRoomRateGuest(params)
          this.close()
          return Promise.resolve();
        },300)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/AdjustPax.vue